$('.top-search-toggle').on('click', function ( event ) {
    // Stop default action and bubbling
    event.stopPropagation();
    event.preventDefault();

    $("#top-off-canvas-search").toggleClass('slideOpen');
    $("#top-off-canvas-search").slideToggle();

    if ($("#top-off-canvas-search").hasClass('slideOpen')){
        $("#top-off-canvas-search .tx-solr-q").focus();
    }
} );
$("#top-off-canvas-search .close-search").on("click", function(){

    $("#top-off-canvas-search").removeClass('slideOpen');
    $("#top-off-canvas-search").slideUp();
});

$('#top-off-canvas-search .input-group-addon.search-button').on('click', function (event) {
    $(this).parents('form').submit();
})
